import React, { useState } from "react";
import "./Carousel.css"; // Ensure you have custom CSS for the carousel

const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="carousel-container">
      {images.length > 1 && (
        <button className="carousel-button prev" onClick={goToPrevious}>
          &#8249;
        </button>
      )}
      <img
        src={images[currentIndex]}
        alt="Intervention"
        className="carousel-image"
      />
      {images.length > 1 && (
        <button className="carousel-button next" onClick={goToNext}>
          &#8250;
        </button>
      )}
    </div>
  );
};

export default Carousel;
